import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/maintenance.png';
const _hoisted_1 = { class: "content" };
import MGButton from './MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MaintenanceMessage',
    props: {
        title: { default: "We'll be right back" },
        message: { default: "Money Guided is currently unavailable while we carry out some essential maintenance.\nWe'll be as quick as we can, check back within an hour or so.\nThanks for your patience." },
        buttonText: { default: 'Retry' },
        secondaryText: { default: '' },
        overlay: { type: Boolean, default: false }
    },
    emits: ["action", "secondary"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['maintenance', { overlay: _ctx.overlay }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _cache[2] || (_cache[2] = _createElementVNode("img", {
                        src: _imports_0,
                        alt: "MoneyGuided",
                        class: "avatar"
                    }, null, -1)),
                    _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.message), 1),
                    _createVNode(MGButton, {
                        text: _ctx.buttonText,
                        fullWidth: true,
                        outline: !_ctx.secondaryText,
                        arrow: !!_ctx.secondaryText,
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('action')))
                    }, null, 8, ["text", "outline", "arrow"]),
                    (_ctx.secondaryText)
                        ? (_openBlock(), _createBlock(MGButton, {
                            key: 0,
                            text: _ctx.secondaryText,
                            fullWidth: true,
                            outline: true,
                            stacked: true,
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('secondary')))
                        }, null, 8, ["text"]))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
